import React, { useCallback, useState } from "react";
import { Button, Confirmation } from "@core/uilibrary";
import "../../css/button-decision.css";
import { useSettingsDraft } from "../../../../../context-controller-mod/context-serv/global-provider/setting-context/settings-draft.context";
import { useGlobalPopupProvider } from "../../../../../context-controller-mod/context-serv/popup-provider/ts/globalPopupProvider";
import { useToast } from "../../../../../context-controller-mod/context-serv/toast-provider/bottomToast/ts/ToastProvider";
import { SuccessDocConfirmationIcon } from "../../../../../asset-controller-mod/asset-serv/icons/iconExporter";

const ButtonDecision = () => {
  const { isDirty, saveAll } = useSettingsDraft();
  const { openConfirm, closeConfirm } = useGlobalPopupProvider();
  const { showToast } = useToast();

  const [saving, setSaving] = useState(false);

  const handleConfirmRequest = useCallback(() => {
    openConfirm(
      <Confirmation
        visible
        title="Save setting?"
        description="Any change in setting will effect the system."
        status="info"
        icon={<SuccessDocConfirmationIcon/>}
        onClose={closeConfirm}
        buttons={
          <>
            <Button
              variant="ghost"
              size="md"
              value="Cancel"
              type="button"
              disabled={saving}
              onClick={() => closeConfirm()}
            />

            <Button
              variant="primary"
              size="md"
              value={saving ? "Saving..." : "Confirm"}
              type="button"
              disabled={saving}
              onClick={async () => {
                try {
                  setSaving(true);
                  const res = await saveAll();
                  if(res?.didPatch === true){
                    showToast({
                      status: 'success',
                      title: 'Setting Saved',
                      description: 'Setting update successfully.',
                    });
                  }else{
                    showToast({
                      status: 'warning',
                      title: 'Uncompleted !',
                      description: 'No setting were changed!',
                    });
                  }
                  closeConfirm();
                } catch (e) {
                  if(e){
                    showToast({
                      status: 'error',
                      title: 'Uncompleted !',
                      description: 'Setting update was saved unsuccessfully.',
                    });
                  }
                  
                } finally {
                  setSaving(false);
                }
              }}
            />
          </>
        }
      />
    );
  }, [openConfirm, closeConfirm, saveAll, saving]);

  return (
    <section className="scl--set-deci-const-sty">
      <Button value="Back" variant="ghost" />

      <Button
        value={saving ? "Saving..." : "Save"}
        variant="primary"
        disabled={!isDirty || saving}
        onClick={handleConfirmRequest}
      />
    </section>
  );
};

export default ButtonDecision;